export const SET_PROFILE = "SET_PROFILE";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const SET_DEPARTMENTS = "SET_DEPARTMENTS";
export const SET_JOBTITLE = "SET_JOBTITLE";
export const SET_POSITIONS = "SET_POSITIONS";
export const SET_PROCEDURE_DETAIL_STATUS = "SET_PROCEDURE_DETAIL_STATUS"
export const SET_PROCEDURE_STATUS = "SET_PROCEDURE_STATUS"
export const SET_NOTICE_PIN = "SET_NOTICE_PIN"
export const SET_SIDER_COLLAPSED = "SET_SIDER_COLLAPSED"
export const SET_DOC_CONTRACT = "SET_DOC_CONTRACT"
export const SET_TOKEN_EXPIRED_EMAIL = "SET_TOKEN_EXPIRED_EMAIL"
export const SET_THEME_MODE = "SET_THEME_MODE";
